<template>
  <div class="page-team">
    <!-- 联合创始人 -->
    <SRF>
      <BoosBanner :leaderList="leaderList" />
    </SRF>
    <!-- 我们的团队 -->
    <SRF>
      <OurTeam />
    </SRF>
    <!-- 人物 -->
    <SRF>
      <PersonSwiper :teamList="teamList" />
    </SRF>
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import BoosBanner from "./components/BoosBanner";
import OurTeam from "./components/OurTeam";
import PersonSwiper from "./components/PersonSwiper";
import Footer from "@/components/Footer";
import { pageApi } from "@/api";
export default {
  components: {
    BoosBanner,
    OurTeam,
    PersonSwiper,
    Footer,
  },
  data() {
    return {
      teamList: [],
      leaderList: [],
    };
  },
  mounted() {
    // console.log(this.$ismobile)//是否为移动端
    // if (this.$ismobile) {
    //   this.$router.push({
    //     path: "/phone/team"
    //   });
    // } else {
    // }
    this.getData();

  },
  methods: {
    async getData() {
      const res = await pageApi.getTeamList();
      const data = res.result;
      this.teamList = data.tuan_arr;
      this.leaderList = data.leader_arr;
    },
  },
};
</script>

<style scoped lang="scss">
@import url("./index.scss");
</style>
